import * as t from 'io-ts';
import { StateDynamicType } from './state';

export const CountryDynamicType = t.interface({
    id: t.string,
    name: t.string,
    code: t.union([t.string, t.null]),
    callingCode: t.union([t.string, t.null]),
    stateType: t.union([
        t.literal('NONE'),
        t.literal('STATE'),
        t.literal('PROVINCE')
    ]),
    states: t.array(StateDynamicType)
});

export type Country = t.TypeOf<typeof CountryDynamicType>;
